import React from 'react';
import { cn } from '../../lib/utils';

/**
 * Grid of selectable preset cards — id-based selection.
 *
 * Default rendering shows a simple text label. Use `renderItem` for custom content
 * (e.g., icons + text for shape pickers).
 *
 * @param {Object}   props
 * @param {Array}    props.items     — Array of objects with at least `{ id, name }`
 * @param {string}   props.value     — Currently selected item ID
 * @param {Function} props.onChange   — (itemId: string) => void
 * @param {number}   [props.columns]  — Grid columns (default: 4)
 * @param {Function} [props.renderItem] — (item, isActive) => React element
 */
export function PresetGrid({
  items,
  value,
  onChange,
  columns = 4,
  renderItem,
}) {
  return (
    <div className="grid gap-1.5" style={{ gridTemplateColumns: `repeat(${columns}, 1fr)` }}>
      {items.map((item) => {
        const isActive = value === item.id;
        return (
          <button
            key={item.id}
            onClick={() => onChange(item.id)}
            className={cn(
              'rounded-lg border text-center transition-all',
              renderItem
                ? (isActive ? 'border-white/25 bg-white/10' : 'border-white/8 bg-white/[0.02] hover:bg-white/[0.06]')
                : cn(
                    'py-1.5 text-[10px] font-medium',
                    isActive
                      ? 'border-white/25 bg-white/10 text-white/90'
                      : 'border-white/8 bg-white/[0.02] text-white/45 hover:bg-white/[0.06] hover:text-white/65'
                  )
            )}
          >
            {renderItem ? renderItem(item, isActive) : item.name}
          </button>
        );
      })}
    </div>
  );
}
